
  import * as awsAmplifyRuntime$StquavMnNq54JgAXSvhNNVUPM1JRSGgr_45sQSRfXbwhI from '/codebuild/output/src380848875/src/compass-v2/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "png",
    "webp"
  ],
  "quality": 75
},
    providers: {
        ['awsAmplify']: { provider: awsAmplifyRuntime$StquavMnNq54JgAXSvhNNVUPM1JRSGgr_45sQSRfXbwhI, defaults: {} }
    }
  }
